export default class SimpleParallax {
  constructor() {
    this.parallaxed_elements = document.querySelectorAll('[data-parallax]');
  }

  onScroll(depth) {
    for (let i = 0; i < this.parallaxed_elements.length; i++) {

      let current_element = this.parallaxed_elements[i];
      let speed = (current_element.dataset.parallax) ? parseInt(current_element.dataset.parallax) : 0.4;

      var coords = ((depth * speed) * -1) + 'px';
      current_element.style.transform = 'translateY(' + coords + ')';
    }
  }
}
